import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.4611 21.1536C17.7715 21.1536 22.0765 16.8487 22.0765 11.5382C22.0765 6.2278 17.7715 1.92285 12.4611 1.92285C7.15066 1.92285 2.8457 6.2278 2.8457 11.5382C2.8457 16.8487 7.15066 21.1536 12.4611 21.1536Z",
      fill: "currentColor",
      "fill-opacity": "0.6"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.1815 8.81885L9.74219 14.2581",
      stroke: "white",
      "stroke-width": "1.83333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.74219 8.81885L15.1815 14.2581",
      stroke: "white",
      "stroke-width": "1.83333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }